import { render, staticRenderFns } from "./RechnungshintergrundEinstellungen.vue?vue&type=template&id=66c57042&scoped=true"
import script from "./RechnungshintergrundEinstellungen.vue?vue&type=script&lang=js"
export * from "./RechnungshintergrundEinstellungen.vue?vue&type=script&lang=js"
import style0 from "./RechnungshintergrundEinstellungen.vue?vue&type=style&index=0&id=66c57042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c57042",
  null
  
)

export default component.exports